// @flow

import {
  call,
  select,
} from 'redux-saga/effects'

import {ensureMapReady} from './ensureMapReady'
import {fetchPartnerServiceProviders} from '../lib/fetchPartnerServiceProviders'
import {mapSelectors} from '../selectors'
 
export function* loadServiceProvidersFromLocation(fromLocation: string='POINT(100.5424854+13.7851192)'): Effect {
  yield call(ensureMapReady)
  try {
    const apiIndex: ApiIndex<MapApi> = yield select(mapSelectors.getApiIndex)
    const serviceProviders: ServiceProvider[] = yield call(fetchPartnerServiceProviders, apiIndex, fromLocation)
    return serviceProviders
  } catch (error) {
    console.log(error) 
  }
  return []
}
